import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import useDebounce from 'utils/customHook/useDebounce'
import SimpleSelectionTable from 'components/datatable/SimpleSelectionTable'
import { nbPerPageLabelTiny } from 'referencial/constants/ReferencialConstants'

const PiezoDataTypes = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = () => {},
    getGlobalModuleParameter = () => {},
    piezometryDataTypes = [],
    isGlobal = false,
}) => {
    const parameter = 'PIEZOMETER_DATA_TYPE'

    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [piezoDataType, setPiezoDataType] = useState(foundParameter ? foundParameter.split(',').map(e => Number(e)) : [])
    const [modulePiezoDataType, setModulePiezoDataType] = useState(foundModuleParameter ? foundModuleParameter.split(',').map(e => Number(e)) : [])

    const onChange = (e) => {
        if (isGlobal) {
            setPiezoDataType(e)
        } else {
            setModulePiezoDataType(e)
        }
    }

    const selectedList = isGlobal ? piezoDataType : modulePiezoDataType

    useDebounce(() => {
        setParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalParameter(parameter, `${piezoDataType}`),
        ])
    }, 200, [piezoDataType])

    useDebounce(() => {
        setModuleParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalModuleParameter(parameter, `${modulePiezoDataType}`),
        ])
    }, 200, [modulePiezoDataType])

    return (
        <Grid size={12} justifyContent='space-between' alignItems='center' columnSpacing={1} spacing={1} paddingX={6}>
            <Accordion>
                <AccordionSummary>
                    {isGlobal ? i18n.dataTypes : i18n.dataTypesVisibleOnThisModule}
                </AccordionSummary>
                <AccordionDetails>
                    <Stack spacing={1}>
                        {!isGlobal && <Typography fontStyle='italic'>{i18n.configurationOfTheApplicationWillNotBeModified}</Typography>}
                        <SimpleSelectionTable
                            onChange={onChange}

                            listData={piezometryDataTypes}
                            selectedList={selectedList}

                            listHeaders={['id', 'label']}
                            listTitle={i18n.nonSelectedParameters}
                            selectedListTitle={i18n.selectedParameters}

                            nbPerPage={nbPerPageLabelTiny}
                        />
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </Grid>
    )
}

PiezoDataTypes.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    piezometryDataTypes: PropTypes.arrayOf(PropTypes.shape({})),
    isGlobal: PropTypes.bool,
}

export default PiezoDataTypes
